import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_NOTIFICATION',
  READ: 'READ_NOTIFICATION',
};

export const listNotification = () => ({
  type: ACTION.LIST,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_NOTIFICATION,
    params: {
      ordering: '-id',
    },
  }).catch(err => Promise.reject(err.response.data.detail)),
});

export const readNotification = ids => {
  const data = {
    ids,
  };

  return {
    type: ACTION.READ,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_NOTIFICATION}reads/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/notification/notification_actions.js